/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type QuickViewCategoryParagraph_itemSearch = {
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly pageType: string | null;
    readonly " $refType": "QuickViewCategoryParagraph_itemSearch";
};
export type QuickViewCategoryParagraph_itemSearch$data = QuickViewCategoryParagraph_itemSearch;
export type QuickViewCategoryParagraph_itemSearch$key = {
    readonly " $data"?: QuickViewCategoryParagraph_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"QuickViewCategoryParagraph_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuickViewCategoryParagraph_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pageType",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'eb9af39633fca8139794552abfed63e0';
export default node;
